module.exports = __webpack_public_path__ + "static/media/Logo_Facimex.91cf7558.png";